// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../~/react-admin-panel/lib/bundle.css
// module id = 369
// module chunks = 0